import Examples from "Examples";
import FuzzySearch from "fuzzy-search";
import useSearchQuery from "Hooks/useSearchQuery";
import { useMemo } from "react";
import Content from "Types/Content";

const useExamplesSugestions = (): Content[] => {
  const query = useSearchQuery();
  const search = useMemo(() => query.get("query"), [query]);
  const fuzzySearcher = useMemo(
    () =>
      new FuzzySearch(Examples, ["title", "route", "tags"], {
        caseSensitive: false,
        sort: true
      }),
    []
  );
  return useMemo(
    () => (search ? fuzzySearcher.search(search) : []),
    [search, fuzzySearcher]
  );
};

export default useExamplesSugestions;
